var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLockQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.4118C3 10.632 3.64472 10 4.44 10H19.56C20.3553 10 21 10.632 21 11.4118V19.1765C21 20.7359 19.7106 22 18.12 22H5.88C4.28942 22 3 20.7359 3 19.1765V11.4118Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7428 14.7571C10.7428 14.7571 10.938 13 12.4999 13C14.0618 13 14.2571 13.9762 14.2571 14.7571C14.2571 15.3439 13.9264 15.9307 13.2651 16.1862C12.8629 16.3416 12.4999 16.6687 12.4999 17.1V18.0483",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7428 14.7571C10.7428 14.7571 10.938 13 12.4999 13C14.0618 13 14.2571 13.9762 14.2571 14.7571C14.2571 15.3439 13.9264 15.9307 13.2651 16.1862C12.8629 16.3416 12.4999 16.6687 12.4999 17.1V18.0483",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8903 19.4428C12.8903 19.6585 12.7155 19.8333 12.4999 19.8333C12.2842 19.8333 12.1094 19.6585 12.1094 19.4428C12.1094 19.2272 12.2842 19.0524 12.4999 19.0524C12.7155 19.0524 12.8903 19.2272 12.8903 19.4428Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00286 10V9.78115C6.00286 7.609 5.87032 5.18783 7.40896 3.63325C8.28642 2.74671 9.70627 2 12 2C14.2937 2 15.7136 2.74671 16.591 3.63325C18.1296 5.18783 17.9971 7.609 17.9971 9.78115V10",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLockQuestionMark);
export default __webpack_public_path__ + "static/media/BlackLockQuestionMark.c3dcbb2d56f62956f48a676e1eaead30.svg";
export { ForwardRef as ReactComponent };